import { toggleSocialIconList } from './utils/social.js'
import { initializeGallerySlider, handleRefreshModal } from './utils/slick.js'
import MenuTracker from './components/menu-tracker.js'
;(function ($) {
    'use strict'

    $(function () {
        // Open modal if present in URL hash
        const $target = $(':target')
        if ($target.length > 0 && $target.hasClass('modal')) {
            $target.modal('show')
        }

        $('[data-toggle="social-icon-list"]').on('click', toggleSocialIconList)

        // Smooth filtering of articles
        const filters = document.querySelectorAll('#category-nav button[data-filter-category]')
        const articles = document.querySelectorAll('#histories-list > article')

        filters.forEach((btn) =>
            btn.addEventListener('click', function () {
                updateFilters(this, articles)
                updateFilteredCategory(this)
                updateActiveCategory(this, filters)
            })
        )

        // Update URL hash when opening a modal
        $('.modal').on('show.bs.modal', updateModalHash)

        // Initialitze gallery slick slider in modal
        $('.modal').one('shown.bs.modal', initializeGallerySlider)

        $('.modal').on('hidden.bs.modal', function () {
            // Reposition modal on resize
            handleRefreshModal(this)

            // Remove hash from URL if present
            if (window.location.hash) {
                history.replaceState(null, '', '.')
            }
        })

        // Initialize category filter menu tracker
        const categoryMenuTracker = new MenuTracker({
            wrapperSelector: '#category-nav',
            menuSelector: 'ul',
        })
    }) // END Document Ready

    const updateFilters = (btn, articles) => {
        const filteredCategory = btn.dataset.filterCategory || 'all' // Get the filtered category

        // Toggle visibility of each article ('none' for filtered ones, 'inline-flex' for matching ones)
        articles.forEach((item) => {
            const category = item.dataset.category
            const match =
                filteredCategory === 'all' || category.split(',').includes(filteredCategory)
            if (match) {
                $(item).delay(451).fadeIn()
            } else {
                $(item).fadeOut(450)
            }
        })
    }

    const updateFilteredCategory = (btn) => {
        const categoryHeaders = document.querySelectorAll('#category-info > .category-header')
        const categoryDescription = document.querySelectorAll(
            '#category-info > .category-description'
        )
        const filteredCategory = btn.dataset.filterCategory || 'all' // Get the filtered category

        // Slide up/down category info when filtering all/one category
        if (filteredCategory === 'all') {
            $('#category-info').slideUp(500)
        } else {
            $('#category-info').slideDown()
        }

        // Toggle visibility of each category header ('none' for filtered ones, 'block' for matching ones)
        categoryHeaders.forEach((item) => {
            const category = item.dataset.category
            const match = filteredCategory === category
            if (match) {
                $(item).delay(400).fadeIn()
            } else {
                $(item).fadeOut()
            }
        })

        // Toggle visibility of each category description ('none' for filtered ones, 'block' for matching ones)
        categoryDescription.forEach((item) => {
            const category = item.dataset.category
            const match = filteredCategory === category
            if (match) {
                $(item).delay(400).fadeIn()
            } else {
                $(item).fadeOut()
            }
        })
    }

    const updateActiveCategory = (btn, filters) => {
        const $filters = $(filters)
        const $btn = $(btn)

        $filters.parent('li').removeClass('active')
        $btn.parent('li').addClass('active')

        $filters.attr('aria-current', 'false')
        $btn.attr('aria-current', 'true')
    }

    const updateModalHash = (e) => {
        const modal = e.target
        const modalId = modal.getAttribute('id')

        // Update URL hash with the modal ID
        if (modalId) {
            history.pushState(null, '', `#${modalId}`)
        }
    }
})(jQuery)
